$(function(){
    //formareaのみ実行
    if($('.formarea').length){

        //離脱の警告
        $(window).on('beforeunload', function() {
            return 'フォームは未送信です。\n' +
                'このままページを移動するとフォームに入力したデータは保存されません。';
        });
        $('.js-no-withdrawal').on('click', function(e) {
            $(window).off('beforeunload');
        });

        // カタ自動補完
        $.fn.autoKana('#name', '#kana', {
            katakana : false  //true：カタカナ、false：ひらがな（デフォルト）
        });

        // 住所自動補完が完了したら
        // AjaxZip3.onSuccess = function() {
        //     $('select[name=pref]').focus(); // 番地、建物名にフォーカス
        //     $('select[name=pref]').css({'color':'#000'}); //色変更
        // };
        // $("#zip").attr('onKeyUp', 'AjaxZip3.zip2addr(this,\'\',\'pref\',\'pref\');');

    }

});